import { formatPrice } from 'V2/Step/Helpers/CurrencyFormat/CurrencyFormat';
import { formatDateShort } from 'V2/Utilities/DateHelpers/DateHelpers';
import { BindSummary } from './types';

export interface BindSummaryResponse {
  email?: string;
  policy: {
    policyNumber: string;
    termInfo: { effectivePeriod: { startDate: string } };
    policyAmounts: Array<{ amountType: string; amount: { value: number } }>;
    paymentPlan: {
      paymentMethod: string;
      paymentFrequency: string;
      downPaymentAmount: number;
      installmentAmount: number;
      lastFourDigits?: string;
    };
  };
}

const formatFrequency = (freq: string): string => {
  if (freq.includes('weekly')) return 'weekly';
  if (freq.includes('monthly')) return 'monthly';
  return freq.replace(/_/g, ' ');
};

const PAYMENT_METHOD_LABELS: Record<string, string> = {
  credit_card: 'Credit Card',
  debit_card: 'Debit Card',
  ach: 'ACH',
};

const formatPaymentMethod = (method: string): string =>
  PAYMENT_METHOD_LABELS[method] ?? method;

export const transformSummary = (raw: BindSummaryResponse): BindSummary => {
  const { policy } = raw;
  const writtenPremium = policy.policyAmounts.find(
    (a) => a.amountType === 'writtenPremium'
  );
  return {
    policyNumber: policy.policyNumber,
    effectiveDate: formatDateShort(policy.termInfo.effectivePeriod.startDate),
    totalPremium: writtenPremium
      ? (formatPrice(writtenPremium.amount.value) ?? undefined)
      : undefined,
    downPaymentAmount:
      formatPrice(policy.paymentPlan.downPaymentAmount) ?? undefined,
    installmentAmount:
      formatPrice(policy.paymentPlan.installmentAmount) ?? undefined,
    paymentFrequencyLabel: formatFrequency(policy.paymentPlan.paymentFrequency),
    paymentMethod: formatPaymentMethod(policy.paymentPlan.paymentMethod),
    lastFourDigits: policy.paymentPlan.lastFourDigits,
    email: raw.email,
  };
};
